import 'hammerjs';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));



//content-security-policy
const csp = document.createElement('meta')
let mycontent = `default-src 'self' https://api.ipify.org;
script-src 'self' https://code.jquery.com https://cdn.jsdelivr.net  https://cdnjs.cloudflare.com https://stackpath.bootstrapcdn.com https://maps.googleapis.com https://maxcdn.bootstrapcdn.com 'unsafe-inline';
style-src 'self'  https://fonts.googleapis.com https://stackpath.bootstrapcdn.com  https://cdnjs.cloudflare.com 'unsafe-inline';
font-src 'self' https://fonts.googleapis.com  https://fonts.gstatic.com;
connect-src 'self' https://api.ipify.org https://maps.googleapis.com https://cdnjs.cloudflare.com http://localhost:4200 http://localhost:3007 https://uat.samadhan.upnn.co.in:3020 https://samadhan.upnn.co.in:3032;
img-src 'self'  https://api.ipify.org blob: data:;`

csp.setAttribute('http-equiv', 'Content-Security-Policy');
csp.setAttribute('content', mycontent);
document.head.appendChild(csp)





// Create and append the meta tag & links
const faviconLink = document.createElement('link');
faviconLink.setAttribute('rel', 'icon');
faviconLink.setAttribute('type', 'image/x-icon');
faviconLink.setAttribute('href', './assets/img/logo_pcs.jpg');
document.head.appendChild(faviconLink);

const script = document.createElement('script');
script.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBFYlyaMdqSA-Iz92VL0X21l133iHDtjTo&libraries=places&language=en');
document.head.appendChild(script);


const cdnBts = document.createElement('script');
cdnBts.setAttribute('src', 'https://maxcdn.bootstrapcdn.com/bootstrap/4.5.2/js/bootstrap.min.js');
document.head.appendChild(cdnBts);



const googleFont1 = document.createElement('link');
googleFont1.setAttribute('rel', 'stylesheet');
googleFont1.setAttribute('href', 'https://fonts.googleapis.com/css?family=Roboto:300,400,500&display=swap');
document.head.appendChild(googleFont1);


const csvScript = document.createElement('script');
csvScript.setAttribute('src', './assets/js/scripts/CSVExport.js');
document.head.appendChild(csvScript);

